module.exports = __webpack_public_path__ + "media/images/background_graphics/publication_graphic_desktop-4ce381bbfd4737c4eb8ceab49284acbb.svg";